// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode';

const isTokenValid = (tokenPayload: string, tokenRefreshMargin: number) => {
  if (!tokenPayload) {
    return false;
  }

  try {
    const decodedToken = jwt_decode(tokenPayload);
    const isValid = decodedToken.exp * 1000 - tokenRefreshMargin >= Date.now();
    return isValid;
  } catch (error) {
    return false;
  }
};

export { isTokenValid };
